import api from 'data/api';

export const loadPlatforms = api('GET /api/mobile/lookups/platforms');
